import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  HttpService,
  NotificationService, SalesDespatchAnalysis,
  SalesDespatchNoteEmailContacts,
  SalesDespatchNoteReport,
} from 'tms-lib';
import {
  SalesDespatchNoteDetails,
  SalesDespatchNoteForInvoice,
  SalesDespatchNote,
  SalesDespatchNotesCreated,
  ShipmentDetailMagento,
} from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesDespatchNoteService extends TmsWebBaseEditCreateService<SalesDespatchNote, SalesDespatchNoteDetails> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SalesDespatchNote', $localize`Sales Despatch Note`, httpService, notificationService);
  }

  createDespatchNote(ids: string[]): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/CreateDespatchNote`, { ids });
  }

  getCreatedDespatchNotes(ids: string[]): Observable<SalesDespatchNotesCreated[]> {
    return this.httpService.post<SalesDespatchNotesCreated[]>(`${this.apiUrl}/CreatedSalesDespatchNotes`, { ids });
  }

  getDespatchNotesForManifests(): Observable<SalesDespatchNote[]> {
    return this.httpService.get<SalesDespatchNote[]>(`${this.apiUrl}/GetSalesDespatchNotesForManifests`);
  }

  getDespatchNotesForManifest(id: string, shipperSupplierId: string): Observable<SalesDespatchNote[]> {
    return this.httpService.get<SalesDespatchNote[]>(
      `${this.apiUrl}/GetSalesDespatchNotesForManifest?id=${id}&shipperSupplierId=${shipperSupplierId}`,
    );
  }

  getSalesDespatchNoteReport(id: string, html: boolean): Observable<SalesDespatchNoteReport> {
    return this.httpService.get<SalesDespatchNoteReport>(
      `${this.apiUrl}/SalesDespatchNoteReport?id=${id}&html=${html}`,
    );
  }

  getForCreateInvoice(): Observable<SalesDespatchNoteForInvoice[]> {
    return this.httpService.get<SalesDespatchNoteForInvoice[]>(`${this.apiUrl}/GetForCreateInvoice`);
  }

  getSalesDespatchNoteEmailContacts(id: string): Observable<SalesDespatchNoteEmailContacts> {
    return this.httpService.get<SalesDespatchNoteEmailContacts>(
      `${this.apiUrl}/SalesDespatchNoteEmailContacts?id=${id}`,
    );
  }

  getSalesDespatchAnalysis(fromDate: Date, toDate: Date): Observable<SalesDespatchAnalysis[]> {
    return this.httpService.get<SalesDespatchAnalysis[]>(
      `${this.apiUrl}/SalesDespatchAnalysis?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }

  updateWebsiteShipments(shipmentDetails: ShipmentDetailMagento[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateWebsiteShipments`, { shipmentDetails });
  }

  exportFtpCsvMagentoData(): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/FtpCsvMagentoData`);
  }
}
